/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
    TextField,
    Box,
} from '@mui/material';

// @ts-ignore
import { NotificationManager } from 'react-notifications';
import GradientButton from '../MUICustomButton/GradientButton';

const validationSchema = Yup.object().shape({
    phoneNumbers: Yup.string().required('Please enter phone numbers'),
    message: Yup.string().required('Please enter a message'),
});

function SMSCampaignTemplate(): JSX.Element {
    const [isLoading, setIsLoading] = useState(false);


    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = (data:any): void => {
        setIsLoading(true);

        fetch("https://triggeremail-api-dev.hldapps.com/api/sms/send", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ phoneNumbers: data.phoneNumbers, message: data.message }),
        })
            .then((res) => res.json())
            .then((data) => {
                console.log("Success:", data);
                NotificationManager.success('SMS campaign sent successfully!');
            })
            .catch((err) => console.error("Error:", err))
            .finally(() => setIsLoading(false));
    };

    return (       
            <>
                <h2 className="text-2xl font-semibold text-title">SMS Campaign</h2>
                <form onSubmit={(e) => {
                    e.preventDefault();
                    void handleSubmit(onSubmit)(e);
                }} noValidate>
                    <div
                    className="campaign-form-container"
                    style={{ width: '100%' }}
                  >
                        <Box mb={4}>
                            <Controller
                                name="phoneNumbers"
                                control={control}
                                render={({ field }) => (
                                    <>
                                        <TextField
                                            {...field}
                                            fullWidth
                                            label="Phone Numbers*"
                                            variant="outlined"
                                            placeholder='Enter phone numbers separated by commas'
                                            error={!!errors.phoneNumbers}
                                        />
                                        {errors.phoneNumbers && (
                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                {errors.phoneNumbers?.message}
                                            </div>
                                        )}
                                    </>
                                )}
                            />
                        </Box>
                        <Box mb={4}>
                            <Controller
                                name="message"
                                control={control}
                                render={({ field }) => (
                                    <>
                                        <TextField
                                            {...field}
                                            fullWidth
                                            rows={3}
                                            label="Message*"
                                            variant="outlined"
                                            placeholder='Enter message'
                                            error={!!errors.message}
                                        />
                                        {errors.message && (
                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                {errors.message?.message}
                                            </div>
                                        )}
                                    </>
                                )}
                            />
                        </Box>
                        <div className='flex gap-2 justify-end mt-[30px]'>
                        <GradientButton type='submit' color='red' onClick={() => setIsLoading(true)} width='130px'>{!isLoading ? "Submit" : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
                        </div>
                    </div>
                </form>
            </>
    );
}

export default SMSCampaignTemplate;